class LslBundleSave extends HTMLElement {
  connectedCallback() {
    this.inputs = Array.from(this.querySelectorAll('.lsl-bundle__input'));
    if (!this.inputs.length) return;

    this.onChange = this.onChange.bind(this);
    this.inputs.forEach((input) => input.addEventListener('change', this.onChange));

    const selected = this.inputs.find((input) => input.checked) || this.inputs[0];
    this.applyBundle(selected);
  }

  disconnectedCallback() {
    this.inputs?.forEach((input) => input.removeEventListener('change', this.onChange));
  }

  onChange(event) {
    this.applyBundle(event.target);
  }

  getQuantityInputs() {
    return Array.from(document.querySelectorAll('[data-lsl-bundle-qty], .product-form--lastswab [name="quantity"], .sticky-cart__form--lastswab [name="quantity"]'));
  }

  applyBundle(input) {
    if (!input) return;

    const qty = Math.max(1, Number(input.dataset.qty || input.value || 1));

    this.querySelectorAll('.lsl-bundle__card').forEach((card) => {
      card.classList.toggle('is-selected', card.contains(input));
    });

    this.getQuantityInputs().forEach((qtyInput) => {
      qtyInput.value = String(qty);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    });

    this.dataset.selectedQty = String(qty);
    this.dataset.selectedPrice = input.dataset.price || '';
    this.dataset.selectedBadge = input.dataset.badge || '';
  }
}

customElements.define('lsl-bundle-save', LslBundleSave);
